import React from 'react';
import rightArrowIcon from '../../assets/images/righArrowIcon.svg';
import { goTOPageHref, handlePageChange } from '../../utils/readiumUtils';
import { useDispatch, useSelector } from 'react-redux';
import { setTOCOpen } from '../../features/TOC/TOCOpenSlice';
import { TocElement } from '../../types/TocElement';

interface ChapterItemProps {
    chapter: TocElement;
    offset: number;
}

const ChapterItem: React.FC<ChapterItemProps> = ({ chapter, offset }) => {
    const dispatch = useDispatch();
    const isopenToc = useSelector(
        (state: { TOCOpen: { isOpen: boolean } }) => state.TOCOpen.isOpen
    );
    const handleClick = () => {
        goTOPageHref(window, chapter?.href);
        handlePageChange(window)
        dispatch(setTOCOpen(!isopenToc));
    };

    return (
        <div className="chapter-item px-6 py-3 hover:bg-[#F7F9FD]">
            <button
                data-testid="toc-chapter-item-button"
                onClick={handleClick}
                className="w-full h-12 bg-transparent rounded text-black flex flex-row justify-between text-md items-center"
            >
                <div className="flex flex-row items-center">
                    <span className={`text-lg pl-2`}>{chapter.name}</span>
                </div>
                <div className="flex flex-row items-center">
                    <span className="text-[#666666] w-1 text-left">
                        {chapter.page - offset}
                    </span>
                    <span className="pl-20 pr-4">
                        <img src={rightArrowIcon} alt="right arrow icon" />
                    </span>
                </div>
            </button>
        </div>
    );
};

export default ChapterItem;
